export default [
  {
    type: 'select',
    placeholder: '异常类型',
    filed: 'excType',
    default: '',
    options: [
      {
        code: '01',
        name: '预警'
      },
      {
        code: '02',
        name: '故障'
      }
    ]
  },
  {
    type: 'input',
    placeholder: '异常情况',
    filed: 'excSituation',
    default: ''
  }
]
